import { render } from "./ProgramBody.vue?vue&type=template&id=02852faa&scoped=true&ts=true"
import script from "./ProgramBody.vue?vue&type=script&lang=ts"
export * from "./ProgramBody.vue?vue&type=script&lang=ts"

import "./ProgramBody.vue?vue&type=style&index=0&id=02852faa&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02852faa"]])

export default __exports__